var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon",
      attrs: {
        width: "20px",
        height: "20px",
        viewBox: "0 0 1024 1024",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M576 234.666667a21.333333 21.333333 0 1 1-42.666667 0h-21.333333v128h85.333333v-128h-21.333333z",
          fill: "#FF9800",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M138.666667 554.666667a32 32 0 0 1-27.968-47.530667l102.314666-154.453333c17.344-20.416 41.109333-47.125333 56.490667-38.549334 15.466667 8.576 25.045333 33.088 16.469333 48.533334l-119.317333 175.552A32 32 0 0 1 138.666667 554.666667zM458.666667 469.333333c-8.234667 0-16.426667-3.157333-22.634667-9.365333l-85.333333-85.333333a32 32 0 1 1 45.248-45.248l65.706666 65.706666 63.146667-47.36c14.186667-10.538667 34.218667-7.744 44.821333 6.4s7.722667 34.218667-6.4 44.821334l-85.333333 64c-5.738667 4.266667-12.501333 6.378667-19.221333 6.378666zM330.666667 256c-41.216 0-74.666667-33.493333-74.666667-74.666667S289.450667 106.666667 330.666667 106.666667 405.333333 140.16 405.333333 181.333333 371.882667 256 330.666667 256M778.666667 256c-41.216 0-74.666667-33.493333-74.666667-74.666667S737.450667 106.666667 778.666667 106.666667 853.333333 140.16 853.333333 181.333333 819.882667 256 778.666667 256",
          fill: "#FFB74D",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M618.666667 896H128V554.666667h490.666667v341.333333z",
          fill: "#FFA000",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M789.333333 299.584v-0.426667c-3.114667-0.192-6.186667-0.490667-9.322666-0.490666-0.533333 0-1.045333 0.085333-1.578667 0.085333-0.384 0-0.682667-0.085333-1.088-0.085333-3.136 0-6.229333 0.298667-9.344 0.490666v0.149334a134.357333 134.357333 0 0 0-73.877333 30.912 31.445333 31.445333 0 0 0-10.005334 9.152 145.621333 145.621333 0 0 0-19.349333 23.893333l-58.773333 72.064-99.797334 59.904a32 32 0 1 0 32.917334 54.890667l106.666666-64a32.213333 32.213333 0 0 0 10.986667-10.986667l26.581333-33.216L704 896h128l18.901333-226.88c4.010667 1.813333 8.426667 2.88 13.098667 2.88A32 32 0 0 0 896 640V426.666667c0-77.930667-37.333333-122.368-106.666667-127.082667z",
          fill: "#607D8B",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M850.922667 669.12A31.914667 31.914667 0 0 1 832 640V405.333333s-42.666667 170.666667-42.666667 234.666667a73.493333 73.493333 0 0 0 57.941334 72.704l3.648-43.584z",
          fill: "#455A64",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M461.674667 395.093333l-51.669334-63.744c-10.432-12.586667-37.632-32.234667-79.338666-32.234666-72.661333 0-98.389333 23.957333-109.781334 41.258666L177.066667 406.954667l55.808 34.410666c-9.216 49.024-20.010667 107.328-29.034667 155.968h237.610667l-24-155.989333 44.224-46.250667z",
          fill: "#E91E63",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M106.666667 554.666667h533.333333v85.333333H106.666667z",
          fill: "#EF6C00",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }